import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-info-panel',
    templateUrl: './info-panel.component.html',
    styleUrls: ['./info-panel.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoPanelComponent {
  @Input() panelId: string;
  @Input() heading: string;
  @Input() description: string;
  @Input() routerLink: string;

  constructor(private router: Router) {}

  navigate() {
    if (this.routerLink) {
      this.router.navigate([this.routerLink]);
    }
  }
}
